import {newsContentManager} from '../../../api/newsContentManager';
import NewsItem from '../../../api/newsItemEntity';
import { notifyBreadcrumChangeAction } from '../../../common/components/breadcrumb/actions/notifyBreadcrumChange';
import { actionTypes } from '../../../common/constants/actionTypes';

export const fetchNewsItemByIdAction = (id: string) => (dispatch: any) => {

  newsContentManager.fetchNewsItemByIdAsync("/" + id)
    .then((newsItem) => {
      dispatch(fetchNewsItemByIdAsyncCompleted(newsItem));
      dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_NEWS_PAGE, newsItem.title));
    });
};

const fetchNewsItemByIdAsyncCompleted = (newsItem: NewsItem) => ({
  payload: newsItem,
  type: actionTypes.FETCH_NEWS_ITEM_BY_ID_COMPLETED
});


// WEBPACK FOOTER //
// ./src/components/newsPage/actions/fetchNewsItemById.ts